import { Routes, Route } from 'react-router-dom';
import { PaymentProvidersPage } from './pages';

export const PaymentProvidersRoutes = () => {
  return (
    <Routes>
      <Route index element={<PaymentProvidersPage />} />
    </Routes>
  );
};

export default PaymentProvidersRoutes;
